var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 934,
    height: 1433,
    viewBox: "0 0 934 1433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37,
    filter: "url(#filter0_f_728_594)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 716.5,
    r: 430.5,
    transform: "rotate(55 217.5 716.5)",
    fill: "url(#paint0_linear_728_594)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_728_594",
    x: -498.637,
    y: 0.362762,
    width: 1432.27,
    height: 1432.27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 142.8,
    result: "effect1_foregroundBlur_728_594"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_728_594",
    x1: 217.5,
    y1: 422.566,
    x2: 217.5,
    y2: 1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870937,
    stopColor: "#0085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white",
    stopOpacity: 0.903003
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightLeft);
export default __webpack_public_path__ + "static/media/lightLeft.54176a5ee585a9fa2a644d97ec64549a.svg";
export { ForwardRef as ReactComponent };